import React, { useState, useEffect } from 'react';
import { getSettings } from '../../util/getSettings';

const Counter = ({ label, onCountChange, countValue }) => {
  const [count, setCount] = useState(null);
  const settings = getSettings(['century', 'settings']);

  useEffect(() => {
    setCount(countValue ? countValue : 1);
  }, [countValue]);

  return (
    <div className="counter">
      <label className="counter__label" htmlFor={`${label}-count`}>{label}</label>
      <div>
        <input
          type="button"
          className="counter__button"
          aria-label="Remove"
          onClick={
            count === 1
              ? () => {
                  setCount(count);
                  onCountChange(count);
                }
              : () => {
                  setCount(count - 1);
                  onCountChange(count - 1);
                }
          }
          style={{ backgroundImage: `url(${settings.minusIcon})` }}
        />
        <input className="counter__input" value={`${count}+`} readOnly id={`${label}-count`}/>
        <input
          type="button"
          className="counter__button"
          aria-label="Add"
          onClick={() => {
            setCount(count + 1);
            onCountChange(count + 1);
          }}
          style={{ backgroundImage: `url(${settings.plusIcon})` }}
        />
      </div>
      <div aria-live="polite" className='sr-only'>{count + '+ ' + label}</div>
    </div>
  );
};

export default Counter;
